import { Components } from '@mui/material';

export default {
  styleOverrides: {
    fill: 'text.secondary',
  },
} as Components['MuiSvgIcon'];
